import apiUrl from '../../../../../utils/settings';

export const ShopInsurancesUrl = () => {
    return apiUrl + '/v2/benefit-beneficiary/shop-insurance';
};

export const ShopInsurancesInfoUrl = () => {
    return apiUrl + '/v2/benefit-beneficiary/shop-insurance/form-info';
};






